import { Component, OnInit, Input, ViewChild, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { EmploymentVerification, EmployerVerificationData } from 'src/app/models/ApplicantDataResponses/ApplicantDataResponses';
import { NgForm } from '@angular/forms';
import { ScreeningAdditionalData, ObjectUpdatePayload, Screening, ScreeningLight, ApplicantDocument, ScreeningNote } from 'src/app/models/screeningInvite';
import { ToastrService } from 'ngx-toastr';
import { SearchPackageService } from 'src/app/services/search-package.service';
import { ApplicantDataService } from 'src/app/services/applicant-data.service';
import { AuthService } from 'src/app/services/auth.service';
import { Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ScreeningService } from 'src/app/screening-module/services/screening.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';
import { GroupApplicantsService } from 'src/app/services/group-applicants.service';

@Component({
  selector: 'app-employment-verification-form',
  templateUrl: './employment-verification-form.component.html',
  styleUrls: ['./employment-verification-form.component.less']
})
export class EmploymentVerificationFormComponent implements OnInit {

  empVerModel : EmploymentVerification;
  @Input() ase : ScreeningAdditionalData;
  @Input() groupId : string;
  @Input() screeningToEdit : ScreeningLight;
  applicantSuppliedData : EmployerVerificationData;
  @Output() noteAdded: EventEmitter<ScreeningNote> = new EventEmitter();
  // @Input() applicantDocuments: ApplicantDocument[];

  groupedScreenings: Screening[] = [];
  @ViewChild('form', {}) ngForm: NgForm;

  displayForm: boolean = false;

  loaded : boolean = false;
  changes : any[] = [];
  originalValues: any[] = [];
  updates : ObjectUpdatePayload[] = [];

  startingIncome: number;
  formChangesSubscription : Subscription;
  searchProcessing : boolean;
  soloScreening: Screening;

  public get activeScreening() : Screening {
    // if(this.groupedScreenings.length > 0) {
    //   return this.groupedScreenings.find(s => { return s.id === this.ase.screeningId });
    // } else if(this.soloScreening) {
      return this.soloScreening;
    // } else return new Screening();
  }

  public get model() : EmploymentVerification {
    return this.empVerModel;
  }

  constructor(private toast : ToastrService, private searches : SearchPackageService, public appData : ApplicantDataService, public groupSvc : GroupApplicantsService,
    private auth : AuthService,public modalService: NgbModal, public screening: ScreeningService, public router: Router) { }
  ngOnInit() {
    console.warn(this.ase);
    //RIQ-1913: fetch the members of the group, as well as the income for the current screening
    // if(this.groupId){
    //   this.groupSvc.getGroupedScreenings(this.groupId).subscribe((res: Screening[]) => {
    //     this.groupedScreenings = res;
    //     this.startingIncome = this.activeScreening.monthlyIncome;
    //     });
  
    // }
    // else {
      //otherwise fetch the solo screening
      this.screening.GetScreening(this.screeningToEdit.screeningToken).subscribe((res: Screening) => {
        this.soloScreening = res;
        this.startingIncome = res.monthlyIncome;
      },
      err => {},
      () => {});

    // }

    this.appData.GetApplicantEmploymentData(this.ase.screeningId).subscribe((scc: EmployerVerificationData)=>{
      this.applicantSuppliedData = scc;
      console.log(this.applicantSuppliedData)
    });

    this.appData.GetEmploymentVerifications(this.ase.searchEntryId).subscribe((vers : EmploymentVerification) => {
      
        if(!vers)
        {
          this.empVerModel = new EmploymentVerification();
          this.empVerModel.orderId = this.ase.searchEntryId;
        }
        else this.empVerModel = vers;
        console.log(this.empVerModel)
      this.setupFormSubs();
      this.loaded = true;
    },
    (err : any) => {})  
  }

  public showForm(): void {
    this.displayForm = !this.displayForm; 
  }

  editScreening(scrn: Screening) : void {
    window.open(environment.portal + `/screenings/review/${scrn.id}`);
  }

  screeningNoteAdded(scrn: ScreeningNote) {
    this.noteAdded.emit(scrn);
  }

  setupFormSubs() : void {
    this.ngForm.statusChanges.subscribe(x=>{
      let keys = Object.keys(this.ngForm.controls)
      keys.forEach(element=>{
        if(!this.originalValues[element]){
          //Object.assign(this.ngForm.controls[element].value,this.originalValues[element]);'
          this.originalValues[element] = this.ngForm.controls[element].value;
        }
      });
    });

    this.formChangesSubscription = this.ngForm.form.valueChanges.subscribe(x => {
      if (this.ngForm.dirty) {
        let keys = Object.keys(x)
        keys.forEach(element => {
          if (this.originalValues[element] != x[element]) {
            if (this.changes.find(r => r.name == element)) {
              this.changes.find(r => r.name == element).value = x[element];
            }
            else {
              this.changes.push({ name: element, value: x[element] });
            }
          }
        });
      }
    })
  }

  sendSearchForProcessing() : void {
      if(this.searchProcessing)
      {
        this.toast.warning('Your Previous Search needs a couple more seconds to run');
        return;
      }
      this.searchProcessing = true;
      this.searches.runManualSearch(this.ase.searchEntryId).subscribe((res : boolean) => {
  
        setTimeout(() =>{
          if(res) {
            this.toast.success('Running search!');
          } else {
            this.toast.error(`${this.ase.searchName} failed to run!`, '', { closeButton: true, disableTimeOut: true });
          }
          this.searchProcessing = false
        } ,5000);
      },
      error => {
        this.toast.error(`${this.ase.searchName} failed to run!`, '', { closeButton: true, disableTimeOut: true });
      });
    }

  saveEmpVer(toComplete: boolean = false) {
    if(toComplete){
      var newState : number = 8;
      this.searches.updateSearchStatus(this.ase.searchEntryId, newState).subscribe((res : any) => {
        if(res.success) {
          this.toast.success('Search status updated!');
          this.ase.searchStatus = newState;
          this.activeScreening.screeningStatus = res.reportStatus;
          this.screening.screenings[0].reportStatus = res.reportStatus;
          if(newState == 8) this.modalService.dismissAll();
        }
        else {
          this.toast.error('Search failed to update!', '', { disableTimeOut: true, closeButton: true });
        }
      },
      error => {
        this.toast.error('Search failed to update!', '', { disableTimeOut: true, closeButton: true });
      },()=>{
        this.runSaveLoop();
      });
    }else{
      this.runSaveLoop();
    }
  }


  runSaveLoop() {
    if(this.model.id > 0 && this.ngForm.valid) {
        this.searches.updateEmpVer(this.model).subscribe(res => {
          if(res) {
            this.model.id = res.id;
            // if(toComplete) this.resetSearchState(8);
            this.toast.success('Successfully updated ResVer information!')
          } else {
            this.toast.error('Failed to update reference verification data!', '', { closeButton: true, disableTimeOut: true })
          }
        },
        (error : any) => {
          this.toast.error('Failed to update reference verification data!', '', { closeButton: true, disableTimeOut: true })
        },()=>{
          // this.checkIncomeForUpdate();
        });

    } else if (this.ngForm.valid) {
      this.searches.saveEmpVerification(this.empVerModel).subscribe((res: any) => {
        if(res) {
          this.empVerModel.responseId = res.responseId
          //RIQ-1938: set the model id and the excludeFromReport flag so we can save the initial emp ver and then process updates correctly without closing the dialog.
          this.empVerModel.id = res.id;
          this.empVerModel.excludeFromReport = false;
          this.appData._verifyEmploy = this.empVerModel;
          this.toast.success('Successfully saved EmpVer information!')
        }
        else {
          this.toast.error('Failed to save employment verification data!', '', { closeButton: true, disableTimeOut: true })
        }
      },
      (error : any) => {
        this.toast.error('Failed to save employment verification data!', '', { closeButton: true, disableTimeOut: true })
      },()=>{
        //  this.checkIncomeForUpdate();
      });

    } 
  }

  // checkIncomeForUpdate(){
  //   if(this.startingIncome != this.activeScreening.monthlyIncome) {
  //     //RIQ-3187: AS OF THIS TICKET, we are no longer cross-applying income changes!
  //     //all that will be handled in the group-income component
  //     this.screening.UpdateScreeningPIT(this.activeScreening).subscribe(res => {
  //       if(res) this.toast.success(`Income successfully updated for ${this.activeScreening.invitation.id} - ${this.activeScreening.firstName} ${this.activeScreening.lastName}`);
  //     },
  //     err => {this.toast.error('error updating income')},
  //     () => {});
  //   }
  // }

  // resetSearchState(newState : number) : void {
  //   this.searches.updateSearchStatus(this.ase.searchEntryId, newState).subscribe((res : boolean) => {
  //     if(res) {
  //       this.toast.success('Search status updated!');
  //       this.ase.searchStatus = newState;
  //       if(newState == 8) this.modalService.dismissAll();
  //     }
  //     else {
  //       this.toast.error('Search failed to update!', '', { disableTimeOut: true, closeButton: true });
  //     }
  //   },
  //   error => {
  //     this.toast.error('Search failed to update!', '', { disableTimeOut: true, closeButton: true });
  //   },()=>{
  //     this.checkIncomeForUpdate();
  //   });
  // }
}